import { TP } from '../../../constants/consts';

// TODO - Tightly coupled to page using config,
// TODO - we should use props
export const getSubFilterOptions = (t, page) => {
  const subFilterOptions = [
    { label: t(`${TP}.m_LANGUAGES_ALL`), type: 'language_id' },
    { label: t(`${TP}.m_SUBTITLES_ALL`), type: 'subtitle_id' },
    { label: t(`${TP}.m_COUNTRY_ALL`), type: 'country_id' },
    { label: t(`${TP}.m_DATE`), type: 'date' },
  ];
  if (page === 'festival') {
    subFilterOptions.unshift({ label: t(`${TP}.m_YEAR_ALL_FILTERS`), type: 'year_id' });
  }
  if (page === 'company') {
    subFilterOptions.unshift({ label: t(`${TP}.m_SEASONS_ALL`), type: 'season_id' });
  }
  return subFilterOptions;
};
